import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-badges',
  styleUrls: ['./badges.component.scss'],
  templateUrl: './badges.component.html',
})
export class BadgesComponent implements OnInit {
 
  @Input()  Item: any;
  @Input()  NewLine: boolean;
  @Input()  Url: string;

  ngOnInit(): void {
    this.NewLine = this.NewLine || false;
    this.Url = this.Url || ''; 
  }

  garageInvoiceTooltipHTML(Item: any) {
    let onePercentHtml = '';
    if (Item.OnePercent === true ) {
      onePercentHtml = `<br>Korekta 1%`;
    }
    const IssueDateString = `${new Date(Item.IssueDate).getDate()}.${new Date(Item.IssueDate).getMonth() + 1}.${new Date(Item.IssueDate).getFullYear()}`;
    const AddDateString = `${new Date(Item.AddDate).getDate()}.${new Date(Item.AddDate).getMonth() + 1}.${new Date(Item.AddDate).getFullYear()}`;

    var tooltip = `${Item.Number}<br>${Item.NetValue}${onePercentHtml}<br>${IssueDateString}<br>${Item.AddedByUser} - ${AddDateString}`;

    if (Item.Note) {
      tooltip = `${Item.Number}<br>${Item.NetValue}${onePercentHtml}<br>${IssueDateString}<br>${Item.AddedByUser} - ${AddDateString}<br>${Item.Note}`;
    }

    return tooltip;

  }
}
